import React from 'react';
import { IntlProvider } from 'react-intl';

import { DEFAULT_LOCALE, detectLocale, type Locale } from './locales';
import { messages } from './messages';

type I18nProviderProps = {
  children: React.ReactNode;
  locale?: string | string[];
};

export const I18nProvider = ({ children, locale: preferredLocale }: I18nProviderProps) => {
  const [locale, setLocale] = React.useState<Locale>(() => detectLocale(preferredLocale));

  React.useEffect(() => {
    setLocale(detectLocale(preferredLocale));
  }, [preferredLocale]);

  const intlMessages = React.useMemo(() => messages[locale] ?? messages[DEFAULT_LOCALE], [locale]);

  return (
    <IntlProvider
      key={locale}
      locale={locale}
      defaultLocale={DEFAULT_LOCALE}
      messages={intlMessages}
      onError={() => undefined}
    >
      {children}
    </IntlProvider>
  );
};
